// The web handover form's one contact field (docs/plans/2026-10-11-web-handover-form,
// Task 3, light card). An "@" means an e-mail, anything else a WhatsApp number.
// The checks mirror the API's (`channels/web/handover_form.py`), which stays the
// authority: these only let the card say "check it" before a round trip.

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@.]{2,}$/;
const PHONE_CHARS = /^\+?[\d\s().-]+$/;

// Old saved cards can contain the model's literal "null" instead of JSON null.
export function handoverSubjectText(value) {
  const text = (value ?? '').trim();
  return /^null\.?$/i.test(text) ? '' : text;
}

export function contactKind(value) {
  return String(value || '').includes('@') ? 'email' : 'whatsapp';
}

// What is wrong with a typed contact, as the API's own code ('invalid_email' or
// 'invalid_whatsapp'), or '' when it is fine or empty. Empty is the caller's to
// judge: it is fine on blur and not on send.
export function contactProblem(value) {
  const text = String(value || '').trim();
  if (!text) return '';
  if (contactKind(text) === 'email') {
    return EMAIL.test(text) ? '' : 'invalid_email';
  }
  const digits = text.replace(/\D/g, '');
  return PHONE_CHARS.test(text) && digits.length >= 8 && digits.length <= 15
    ? ''
    : 'invalid_whatsapp';
}

// The submit fields for a typed contact: `{ whatsapp }` or `{ email }`.
export function contactFields(value) {
  const text = String(value || '').trim();
  return contactKind(text) === 'email'
    ? { whatsapp: null, email: text }
    : { whatsapp: text, email: null };
}

// A typed contact fills the card already offered; it does not change its subject.
// Its new read token must still win, because offering a card rotates the token.
export function offeredHandoverForm(event, messages) {
  const form = event.handover_form;
  if (!form || typeof form !== 'object') return null;
  if (!event.used_tools?.includes('fill_handover_form')) return form;
  const previous = messages.findLast((message) => message.handoverForm);
  const previousSubject = handoverSubjectText(previous?.handoverForm.subject);
  return previous && !previous.handoverFormSent && previousSubject
    ? { ...form, subject: previousSubject }
    : form;
}
